<script lang="ts">
	import type { ClassValue } from 'svelte/elements';
	import type { ButtonColor, ButtonVariant } from './types';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import * as m from '$paraglide/messages';
	import Button from './Button.svelte';

	interface Props {
		variant?: ButtonVariant;
		color?: ButtonColor;
		size?: 'md' | 'sm';
		hideTextOnMobile?: boolean;
		labelClasses?: ClassValue;
		class?: ClassValue;
		onclick?: (event: MouseEvent) => void;
	}

	const {
		variant = 'filled',
		color = 'primary',
		size = 'md',
		hideTextOnMobile = false,
		labelClasses,
		class: classes,
		onclick,
	}: Props = $props();

	const { itineraryStore } = getMapLayoutContext() || {};
	const { itineraryHasArrival } = $derived(itineraryStore || {});
</script>

<Button
	icon={$itineraryHasArrival ? 'add' : 'directions'}
	text={$itineraryHasArrival ? m.poi_actions__add_to_itinerary() : m.poi_actions__itinerary()}
	{variant}
	{color}
	{size}
	{hideTextOnMobile}
	class={classes}
	labelClasses={`${labelClasses} text-wrap-balance`}
	noMinWidth={true}
	{onclick}
	onmousedown={e => e.stopPropagation()}
	onpointerdown={e => e.stopPropagation()}
/>
